import {sortBy} from 'lodash'
import constant from '../../libs/constant/constants'

const state = {
  followings:{
    author: [],
    publication: [],
    publisher: [],
    all: [],
    isListAvailable: false
  },
  informationToEdit: {},
  registeredAuthor: [],
  registeredPublisher: [],
  registeredPublication: [],
  accounts: [],
  isRefreshAccounts: false,
  locations: [],
  countryList: []
};

const mutations = {
  SET_USER_FOLLOWINGS(state, payload){
    let stateClone = state
    stateClone.followings.author = payload.AUTHOR || []
    stateClone.followings.publication = payload.PUBLICATION || []
    stateClone.followings.publisher = payload.PUBLISHER || []
    stateClone.followings.isListAvailable = true
    stateClone.followings.all = payload
    state = stateClone
  },
  UPDATE_USER_FOLLOWINGS_AUTHOR(state, payload){
    let stateClone = state
    stateClone.followings.author = payload || []
    stateClone.followings.isListAvailable = true
    stateClone.followings.all.AUTHOR = payload
    state = stateClone
  },
  UPDATE_USER_FOLLOWINGS_PUBLISHER(state, payload){
    let stateClone = state
    stateClone.followings.publisher = payload || []
    stateClone.followings.isListAvailable = true
    stateClone.followings.all.PUBLISHER = payload
    state = stateClone
  },
  UPDATE_USER_FOLLOWINGS_PUBLICATION(state, payload){
    let stateClone = state
    stateClone.followings.publication = payload || []
    stateClone.followings.isListAvailable = true
    stateClone.followings.all.PUBLICATION = payload
    state = stateClone
  },
  SET_INFORMATION_TO_EDIT(state, payload){
    let stateClone = state
    stateClone.informationToEdit = payload
    state = stateClone
  },
  SET_REGISTERED_AUTHOR(state, payload){
    let stateClone = state
    stateClone.registeredAuthor = payload
    state = stateClone
  },
  UPDATE_REGISTERED_AUTHOR(state, payload){
    let stateClone = state
    let registeredAuthor = stateClone.registeredAuthor
    registeredAuthor = registeredAuthor.filter(a => a._id !== payload._id)
    registeredAuthor.push(payload)
    registeredAuthor = sortBy(registeredAuthor, 'name')
    stateClone.registeredAuthor = registeredAuthor
    state = stateClone
  },
  REMOVE_REGISTERED_AUTHOR(state, payload){
    let stateClone = state
    let registeredAuthor = stateClone.registeredAuthor
    registeredAuthor = registeredAuthor.filter(a => a._id !== payload._id)
    registeredAuthor = sortBy(registeredAuthor, 'name')
    stateClone.registeredAuthor = registeredAuthor
    state = stateClone
  },
  SET_REGISTERED_PUBLISHER(state, payload){
    let stateClone = state
    stateClone.registeredPublisher = payload
    state = stateClone
  },
  UPDATE_REGISTERED_PUBLISHER(state, payload){
    let stateClone = state
    let registeredPublisher = stateClone.registeredPublisher
    registeredPublisher = registeredPublisher.filter(a => a._id !== payload._id)
    registeredPublisher.push(payload)
    registeredPublisher = sortBy(registeredPublisher, 'name')
    stateClone.registeredPublisher = registeredPublisher
    state = stateClone
  },
  REMOVE_REGISTERED_PUBLISHER(state, payload){
    let stateClone = state
    let registeredPublisher = stateClone.registeredPublisher
    registeredPublisher = registeredPublisher.filter(a => a._id !== payload._id)
    registeredPublisher = sortBy(registeredPublisher, 'name')
    stateClone.registeredPublisher = registeredPublisher
    state = stateClone
  },
  SET_REGISTERED_PUBLICATION(state, payload){
    let stateClone = state
    stateClone.registeredPublication = payload
    state = stateClone
  },
  UPDATE_REGISTERED_PUBLICATION(state, payload){
    let stateClone = state
    let registeredPublication = stateClone.registeredPublication
    registeredPublication = registeredPublication.filter(a => a._id !== payload._id)
    registeredPublication.push(payload)
    registeredPublication = sortBy(registeredPublication, 'name')
    stateClone.registeredPublication = registeredPublication
    state = stateClone
  },
  REMOVE_REGISTERED_PUBLICATION(state, payload){
    let stateClone = state
    let registeredPublication = stateClone.registeredPublication
    registeredPublication = registeredPublication.filter(a => a._id !== payload._id)
    registeredPublication = sortBy(registeredPublication, 'name')
    stateClone.registeredPublication = registeredPublication
    state = stateClone
  },
  CLEAR_INFORMATION_PORTAL_STORE (state) {
    let stateClone = state
    stateClone.followings = {
      author: [],
      publication: [],
      publisher: [],
      all: [],
      isListAvailable: false
    }
    stateClone.informationToEdit = {}
    stateClone.registeredAuthor = []
    stateClone.registeredPublisher = []
    stateClone.registeredPublication = []
  },
  SET_ACCOUNTS (state, payload) {
    state.accounts = payload
  },
  SET_REFRESH_ACCOUNTS (state, payload) {
    state.isRefreshAccounts = payload
  },
  SET_LOCATIONS (state, payload) {
    state.locations = payload
  },
  SET_COUNTRY_LIST (state, payload) {
    state.countryList = payload;
  }
};

const actions = {
  setUserFollowingsToStore({commit}, payload){
    commit(constant.actions.SET_USER_FOLLOWINGS, payload)
  },
  updateUserFollowingsAuthorToStore({commit}, payload){
    commit('UPDATE_USER_FOLLOWINGS_AUTHOR', payload)
  },
  updateUserFollowingsPublisherToStore({commit}, payload){
    commit('UPDATE_USER_FOLLOWINGS_PUBLISHER', payload)
  },
  updateUserFollowingsPublicationToStore({commit}, payload){
    commit('UPDATE_USER_FOLLOWINGS_PUBLICATION', payload)
  },
  setInformationToEdit({commit}, payload){
    commit('SET_INFORMATION_TO_EDIT', payload)
  },
  setRegisteredAuthor({commit}, payload){
    commit('SET_REGISTERED_AUTHOR', payload)
  },
  updateRegisteredAuthor({commit}, payload){
    commit('UPDATE_REGISTERED_AUTHOR', payload)
  },
  removeRegisteredAuthor({commit}, payload){
    commit('REMOVE_REGISTERED_AUTHOR', payload)
  },
  setRegisteredPublisher({commit}, payload){
    commit('SET_REGISTERED_PUBLISHER', payload)
  },
  updateRegisteredPublisher({commit}, payload){
    commit('UPDATE_REGISTERED_PUBLISHER', payload)
  },
  removeRegisteredPublisher({commit}, payload){
    commit('REMOVE_REGISTERED_PUBLISHER', payload)
  },
  setRegisteredPublication({commit}, payload){
    commit('SET_REGISTERED_PUBLICATION', payload)
  },
  updateRegisteredPublication({commit}, payload){
    commit('UPDATE_REGISTERED_PUBLICATION', payload)
  },
  removeRegisteredPublication({commit}, payload){
    commit('REMOVE_REGISTERED_PUBLICATION', payload)
  },
  clearInformationPortalStore ({commit}) {
    commit('CLEAR_INFORMATION_PORTAL_STORE')
  },
  setAccounts ({commit}, payload) {
    commit('SET_ACCOUNTS', payload)
  },
  setRefreshAccounts ({commit}, payload) {
    commit('SET_REFRESH_ACCOUNTS', payload)
  },
  setLocations ({commit}, payload) {
    commit('SET_LOCATIONS', payload)
  },
  setCountryList ({commit}, payload) {
    commit('SET_COUNTRY_LIST', payload);
  }
};

const getters={
  getUserFollowings(state){
    return state.followings;
  },
  getInformationToEdit(){
    return state.informationToEdit
  },
  getRegisteredAuthor(){
    return state.registeredAuthor
  },
  getRegisteredPublisher(){
    return state.registeredPublisher
  },
  getRegisteredPublication(){
    return state.registeredPublication
  },
  getAccounts (state) {
    return state.accounts
  },
  getRefreshAccounts (state) {
    return state.isRefreshAccounts
  },
  getLocations (state) {
    return state.locations
  },
  getCountryList () {
    return state.countryList;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
}
